module.exports = __webpack_public_path__ + "img/EIO162&162P_1-1.d49ba35c.jpg";